import { BFFError } from "app/constants";

export const shouldRetry = (retryCount: number, error: unknown): boolean => {
  const errorResponse = error as any;
  // Data is not always present
  const { errorCode } = errorResponse?.response?.data || {};

  return !(retryCount >= 2 || errorCode === BFFError.EXPIRED_SESSION || errorCode === BFFError.WRONG_DEVICE);
};
